
namespace TabAurous.Inventory {
    import fld = RepairItemsBOMRow.Fields;

    @Serenity.Decorators.registerClass()
    export class RepairItemsBOMGrid extends Serenity.EntityGrid<RepairItemsBOMRow, any> {
        protected getColumnsKey() { return 'Repair.RepairItemsBOM'; }
        protected getDialogType() { return RepairItemsBOMDialog; }
        protected getIdProperty() { return RepairItemsBOMRow.idProperty; }
        protected getInsertPermission() { return RepairItemsBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return RepairItemsBOMRow.localTextPrefix; }
        protected getService() { return RepairItemsBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    } 
}